<script>
import {emitirDocumentoRetirada, marcarChegou} from '../../../../domain/grv/services'
import UPagination from '../../../_default/components/Uloc/Pagination'
import {debounce} from 'lodash'
import BtnAcoesGrv from './BtnAcaoListaGrv'
import {
  Status,
  StatusTitle,
  STATUS_IMPORTACAO_CEVERA,
  STATUS_TRANSFERIDO_PATIO_CENTRAL
} from '../../../../domain/grv/helpers/GrvStatus'
import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
import DeclaracaoAcessoVeiculoForm from './DeclaracaoAcessoVeiculoForm'
import {GRV_DETRO} from '../../../../domain/grv/helpers/tipos-grv'
import moment from 'moment'
import montaFiltros from '../../../../utils/monta-filtros'
import GrvListaMixins from '../mixins/GrvListaMixins'
import DataFiltroSelect from './grv-lista/DataFiltroSelect'
import createDownloadLink from '../../../../utils/create-download-link'

export default {
  name: 'grvs',
  mixins: [GrvListaMixins],
  components: {
    DataFiltroSelect,
    DeclaracaoAcessoVeiculoForm,
    PopupViewer,
    BtnAcoesGrv,
    UPagination,
    ExcluirGrvAlerta: () => import('./ExcluirGrvAlerta'),
    BloquearGrvLeilaoAlerta: () => import('../../../website/grvs/components/BloquearGrvLeilaoAlerta'),
    HistoricoLeiloesGrv: () => import('../../leiloes/components/HistoricoLeiloesGrv'),
    MapaEdicoesGrv: () => import('../../historico-alteracoes/components/MapaEdicoesGrv')
  },
  data () {
    return {
      filtros: {
        busca: '',
        data: null,
        categoria: null,
        patio: null,
        status: null,
        descending: true,
        sortBy: 'dataApreensao',
        data1: '',
        data2: '',
        tipoGrv: GRV_DETRO,
        contrato: null,
        sucata: false
      },
      prevent: {},
      showDeclaracaoAcessoVeiculoModal: false,
      GRV_DETRO,
      showBloquearGrvLeilaoPopup: false,
      grvSelecionadaParaBloquear: null,
      showExcluirGrvPopup: false,
      grvSelecionadaParaExcluir: null,
      showHistoricoLeiloes: false,
      grvSelecionadaParaVerificarHistoricoDeLeiloes: null,
      showHistoricoAlteracoes: false,
      grvSelecionadaParaVerificarHistoricoDeAlteracoes: null,
      grvSelecionadaDeclaracao: null
    }
  },
  watch: {
    '$route.query.tipoGrv': function (v) {
      this.filtros.tipoGrv = v || GRV_DETRO
      this.start()
    }
  },
  computed: {
    Patios () {
      return this.patios
    },
    Status () {
      let _status = []
      for (const i in Status) {
        if (this.filtros.tipoGrv !== 3 && Number(i) === STATUS_TRANSFERIDO_PATIO_CENTRAL) continue
        if (Number(i) === STATUS_IMPORTACAO_CEVERA) continue
        Status[i].keyValue = i
        _status.push(Status[i])
      }
      return _status
    },
    iconSortingDirection () {
      return this.filtros.descending ? 'up' : 'down'
    }
  },
  created () {
    this.filtros.busca = this.$route.query.grv || ''
    const {tipoGrv} = this.$route.query
    this.filtros.tipoGrv = tipoGrv || GRV_DETRO // TODO: ISSO NÃO ESTÁ 100% SEGURO
  },
  mounted () {
    this.start()
  },
  activated () {
  },
  destroyed () {
//      console.log('destruido')
  },
  methods: {
    dataRetirada ({transferencias, retirada}) {
      const formataData = data => moment(data).format('DD/MM/YYYY HH:mm')
      if (retirada) return formataData(retirada.dataRetirada.date)
      if (!transferencias.length || transferencias[0].patioDestino !== 6) return '----'
      return formataData(transferencias[0].dataChegada.date)
    },
    open (id, status) {
      /* if (status > 0) {
        this.$router.push({name: 'grv.visualizar.patio', params: {id: id}})
      } else {
        this.$router.push({name: 'grv.visualizar', params: {id: id}})
      } */
      this.$router.push({name: 'grv.visualizar', params: {id}})
    },
    changePage (page) {
      console.log('Change page ', page)
      this.pagination.atualPage = page
      this.loadData(this.pagination.limit, page, this.montaFiltros())
    },
    montaFiltros () {
      return montaFiltros(this.filtros)
    },
    sortResults (sortKey) {
      this.filtros.descending = !this.filtros.descending
      this.filtros.sortBy = sortKey
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    pesquisar: debounce(function () {
      let busca = this.filtros.busca
      if (this.prevent.busca === busca) return // previne a repetição de uma chamada de api
      this.prevent.busca = busca
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    }, 500),
    StatusTitle (s, t) {
      return StatusTitle(s, t)
    },
    openDeclaracaoAcessoVeiculoModal ({id, numero, numeroAcessoDeclaracao}) {
      this.showDeclaracaoAcessoVeiculoModal = true
      this.grvSelecionadaDeclaracao = {id, numero, numeroAcessoDeclaracao}
    },
    closeDeclaracaoAcessoVeiculoModal (reload) {
      this.showDeclaracaoAcessoVeiculoModal = false
      this.grvSelecionadaDeclaracao = null
      if (reload === true) this.start()
    },
    emitirDocumentoRetirada ({id, numero}) {
      this.$bar.start()
      this.$loaderOverlay.open().message('Gerando documento, aguarde...')
      emitirDocumentoRetirada(id).then((response) => {
        let callbackEnd = () => {
          createDownloadLink(response.data, `retirada_grv_${numero}.pdf`, false)
          this.$bar.finish()
          this.$loaderOverlay.hide()
        }
        callbackEnd()
      }).catch((response) => {
        this.$bar.finish()
        this.$loaderOverlay.hide()
        this.cadastroError = response.data.errors
        this.$nextTick(() => {
          this.$refs.error.focus()
        })
        console.log(response)
      })
    },
    openBloquearGrvLeilao (id) {
      this.grvSelecionadaParaBloquear = id
      this.showBloquearGrvLeilaoPopup = true
    },
    closeBloquearGrvLeilao () {
      this.grvSelecionadaParaBloquear = null
      this.showBloquearGrvLeilaoPopup = false
    },
    openExcluirGrvPopup (id) {
      this.grvSelecionadaParaExcluir = id
      this.showExcluirGrvPopup = true
    },
    closeExcluirGrvPopup () {
      this.grvSelecionadaParaExcluir = null
      this.showExcluirGrvPopup = false
    },
    openHistoricoLeiloesViewer ({id, cloneOrigemEntityId, numero}) {
      if (String(numero).startsWith('18999') && cloneOrigemEntityId) {
        id = cloneOrigemEntityId
      }
      this.grvSelecionadaParaVerificarHistoricoDeLeiloes = id
      this.showHistoricoLeiloes = true
    },
    closeHistoricoLeiloesViewer () {
      this.grvSelecionadaParaVerificarHistoricoDeLeiloes = null
      this.showHistoricoLeiloes = false
    },
    openHistoricoAlteracoesViewer ({id, cloneOrigemEntityId, numero}) {
      // GRVs de leilão sao clones (numero 18999...) - o historico de alteracoes
      // real fica no registro de origem, nao no clone, igual o de leiloes.
      if (String(numero).startsWith('18999') && cloneOrigemEntityId) {
        id = cloneOrigemEntityId
      }
      this.grvSelecionadaParaVerificarHistoricoDeAlteracoes = id
      this.showHistoricoAlteracoes = true
    },
    closeHistoricoAlteracoesViewer () {
      this.grvSelecionadaParaVerificarHistoricoDeAlteracoes = null
      this.showHistoricoAlteracoes = false
    },
    colorSucata (isSucata) {
      return isSucata ? 'red' : ''
    },
    async marcarChegou ({id, numero}) {
      try {
        const confirma = confirm(`Confirmar chegada da GRV ${numero} ao pátio?`)
        if (!confirma) return
        await marcarChegou(id)
        this.start()
        console.log(`GRV ${id} marcada como chegada`)
      } catch (error) {
        console.error(`Erro ao marcar GRV ${id} como chegada:`, error)
      }
    }
  }
}
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    GRVs {{ tipoGrvLabel }} <span class="badge">{{ this.pagination.totalItems }}</span>
                  </h1>
                  <small class="text-muted">Selecione GRV para modificar</small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                    <router-link
                      :to="{name: 'grv.novo', query: {tipoGrv: filtros.tipoGrv}}"
                      tag="button"
                      class="btn btn-default btn-sm"
                    >
                      <i class="fa fa-plus"></i> Nova GRV
                    </router-link>

                    <!--<u-button class="btn btn-default btn-sm fileContainer hidden-print">
                      <i class="glyphicon glyphicon-import"></i> Importar GRV
                      <input change="importar" accept=".json, application/json" type="file"/>
                    </u-button>-->
                  </div>
                </div>
              </div>
              <!-- Importação aqui se necessário -->
            </div>

            <div class="wrapper-sm" v-if="isLoaded">
              <div class="panel panel-default wrapper-sm" id="filters_main">
                <div class="row m-l-xs m-r-xs" id="filters">
                  <div class="col-md-2">
                    <data-filtro-select @change="reloadData" v-model="filtros.data"
                                        label="Data da Apreensão"></data-filtro-select>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter" for="filtroCategoria">Categoria</label>
                      <select v-model="filtros.categoria" @change="reloadData" id="filtroCategoria"
                              class="form-control">
                        <option :value="null"> Todos</option>
                        <option v-for="categoria in categoriasFiltered" :value="categoria.id"> {{ categoria.nome }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter" for="filtroPatio">Pátio</label>
                      <select id="filtroPatio" @change="reloadData" v-model="filtros.patio" class="form-control">
                        <option :value="null">Todos</option>
                        <option v-for="patio in Patios" :value="patio.id"> {{ patio.nome }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label class="title_filter " for="filtroStatus">Situação</label>
                      <select v-model="filtros.status" @change="reloadData" id="filtroStatus" class="form-control">
                        <option :value="null"> Todos</option>
                        <option v-for="status in Status" :value="status.keyValue"> {{ status.titulo }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="form-group">
                      <label class="title_filter" for="filtroSucata">Sucata</label>
                      <div class="filtro-sucata-switch">
                        <label class="i-switch bg-danger m-r">
                          <input type="checkbox" id="filtroSucata" v-model="filtros.sucata" @change="reloadData">
                          <i></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-9 m-b-xs">
                  <!--<button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Iniciar Campanha de Marketing
                  </button>
                  <div class="btn-group dropdown">
                    <button type="button" class="btn btn-sm btn-default" disabled data-toggle="dropdown">
                      Exportar
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                      <li><a href="">Dropdown link</a></li>
                    </ul>
                  </div>
                  <button class="btn btn-sm btn-default" ng-disabled="pessoaLista.checkeds < 1 ? true : false"
                          aria-disabled="true" disabled="disabled">Deletar
                  </button>-->
                </div>
                <div class="col-sm-3">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                    <span class="input-group-btn">
                      <button class="btn btn-sm btn-default" type="button">Buscar</button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive" style="overflow-x: unset">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(arrayData)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('numero')">
                      GRV <i v-show="filtros.sortBy === 'numero'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th>Placa</th>
                    <th>Chassi</th>
                    <th style="cursor: pointer" @click="sortResults('dataApreensao')">
                      Data da Apreensão <i v-show="filtros.sortBy === 'dataApreensao'"
                                           :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th>Data Retirada</th>
                    <th>Marca/Modelo</th>
                    <th>Pátio</th>
                    <th>Vaga</th>
                    <th>Nº da Chave</th>
                    <th>No Patio</th>
                    <th>Situação</th>
                    <th>Opções</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0" v-for="i in 8">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="data in arrayData" :style="'color: ' + colorSucata(data.sucata)">
                    <td class="v-middle">
                      <label class="i-checks m-b-none">
                        <input
                          v-on:click.stop="lazyCheck(data)"
                          type="checkbox"
                          name="post[]"
                          v-model="data.selected"
                          tabindex="0" aria-checked="false"
                          aria-invalid="false"><i></i>
                      </label>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      <span :class="{'text-danger': data.bloqueadoParaLeilao}">{{ data.numero }}</span> <br>
                      <span class="text-danger" v-if="data.bloqueadoParaLeilao">(Bloqueada para leilões)</span>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      <a class="text-cap custom-link">{{ data.placa || '----' }}</a>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.chassi || '----' }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ moment(data.dataApreensao.date).format('DD/MM/YYYY HH:mm') }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ dataRetirada(data) }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.marca || 'Não informado' }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.patio.nome }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.vaga || '-' }}
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.numeroChave || '-' }}
                    </td>
                    <td>
                      <button
                        v-if="podeMarcarChegou(data)"
                        class="btn btn-success btn-sm"
                        @click="marcarChegou(data)"
                      >
                        <i class="fa fa-check"></i> Chegou
                      </button>
                    </td>
                    <td @click="open(data.id, data.status)" role="button" tabindex="0">
                      <span :style="'color: ' + StatusTitle(data.status, 'color')">{{ StatusTitle(data.status) }}</span>
                    </td>
                    <td role="button" tabindex="0">
                      <btn-acoes-grv
                        :grv="data"
                        :tipoGrv="filtros.tipoGrv"
                        @openDeclaracaoAcessoVeiculo="openDeclaracaoAcessoVeiculoModal"
                        @emitirDocumentoRetirada="emitirDocumentoRetirada"
                        @excluirGrv="openExcluirGrvPopup"
                        @bloquearParaLeilao="openBloquearGrvLeilao"
                        @verHistoricoDeLeiloes="openHistoricoLeiloesViewer"
                        @verHistoricoDeAlteracoes="openHistoricoAlteracoesViewer"
                        @bloqueadoParaLeilao="start"
                      />
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noData">
                    <td colspan="9">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select
                      @change="changePage(1)"
                      v-model="pagination.limit"
                      class="input-sm form-control w-auto inline v-middle"
                    >
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">
                      {{ pagination.atualPage }} / {{ pagination.totalPages }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination
                      @changePage="changePage"
                      :atual="pagination.atualPage"
                      :total="pagination.totalPages"
                    ></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>

      <popup-viewer @close="closeDeclaracaoAcessoVeiculoModal" v-if="showDeclaracaoAcessoVeiculoModal"
                    title="Emitir Declaração de Acesso ao Veículo">
        <DeclaracaoAcessoVeiculoForm
          :grv="grvSelecionadaDeclaracao"
          @finishSubmit="closeDeclaracaoAcessoVeiculoModal"
          @cancel="closeDeclaracaoAcessoVeiculoModal"
          viewer-mode
          ref="declaracao"
        />
      </popup-viewer>
      <popup-viewer title="Excluir GRV" v-if="showExcluirGrvPopup" @close="closeExcluirGrvPopup">
        <ExcluirGrvAlerta @finishSubmit="loadData(pagination.limit, pagination.atualPage, montaFiltros())"
                          :grvId="grvSelecionadaParaExcluir" @cancel="closeExcluirGrvPopup"/>
      </popup-viewer>
      <popup-viewer title="Bloquear GRV para leilão" v-if="showBloquearGrvLeilaoPopup" @close="closeBloquearGrvLeilao">
        <BloquearGrvLeilaoAlerta @finishSubmit="loadData(pagination.limit, pagination.atualPage, montaFiltros())"
                                 :grvId="grvSelecionadaParaBloquear" @cancel="closeBloquearGrvLeilao"/>
      </popup-viewer>
      <popup-viewer @close="closeHistoricoLeiloesViewer" v-if="showHistoricoLeiloes">
        <HistoricoLeiloesGrv :grvId="grvSelecionadaParaVerificarHistoricoDeLeiloes"/>
      </popup-viewer>
      <popup-viewer title="Histórico de Alterações" @close="closeHistoricoAlteracoesViewer" v-if="showHistoricoAlteracoes">
        <MapaEdicoesGrv :grvId="grvSelecionadaParaVerificarHistoricoDeAlteracoes"/>
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
/* Alinha o switch de "Sucata" verticalmente com os demais campos (selects .form-control, 34px de altura) */
.filtro-sucata-switch {
  display: flex;
  align-items: center;
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// ListaGrvs.vue?6b255358